import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { MenuItem, Select, Switch } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import TextField from '../text-field/text-field';
import DatePicker from '../report-frequency-input/date-picker';

import reportParameterTypes from '../../models/report-parameter-types';

const styles = {
  select: {
    width: '100%',
  },
  textField: {
    marginTop: 0,
  },
};

const switchParamFilter = ({ name, setParamValue, value }) => (
  <Switch checked={!!value} color="primary" onChange={e => setParamValue({ name, value: e.target.checked })} />);

const dateParamFilter = ({
  name, setParamValue, value, defaultValues,
}) => {
  return (
    <DatePicker
      value={moment(value) || moment(defaultValues[0], 'DD.MM.YYYY HH:mm:ss')}
      onChange={val => setParamValue({ name, value: val.format() })}
    />
  );
};

const getType = (type) => {
  switch (type) {
    case reportParameterTypes.dateTime:
      return 'date';
    case reportParameterTypes.float:
    case reportParameterTypes.integer:
      return 'number';
    case reportParameterTypes.string:
    default:
      return 'text';
  }
};

const textFieldParamFilter = ({
  value, setParamValue, name, type,
}) => (
  <TextField
    type={getType(type)}
    placeholder="--"
    style={styles.textField}
    value={value}
    onChange={e => setParamValue({ name, value: e.target.value })}
  />
);

const selectParamFilter = ({
  value, validValues, setParamValue, name, defaultValues,
}) => {
  if (!value && !defaultValues) {
    setParamValue({ name, value: validValues[0].value });
  }

  return (
    <Autocomplete
      style={styles.select}
      value={value || (defaultValues ? defaultValues[0] : validValues[0].value)}
      onChange={(_, val) => setParamValue({ name, value: val ? val.value : undefined })}
      options={validValues}
      getOptionLabel={option => (option.label == null ? validValues.find(v => v.value === option).label : option.label)}
      getOptionSelected={(option, val) => option.value === val}
      renderInput={(params => <TextField style={styles.textField} {...params} />)}
    />
  );
};

const ParamFilter = ({ param, setParamValue }) => {
  const {
    type,
  } = param;

  switch (type) {
    case reportParameterTypes.boolean:
      return switchParamFilter({ ...param, setParamValue });
    case reportParameterTypes.dateTime:
      return dateParamFilter({ ...param, setParamValue });
    default:
      return param.validValues
        ? selectParamFilter({ ...param, setParamValue }) : textFieldParamFilter({ ...param, setParamValue });
  }
};

ParamFilter.propTypes = {
  param: PropTypes.object.isRequired,
  setParamValue: PropTypes.func.isRequired,
};

ParamFilter.defaultProps = {
};

export default ParamFilter;
